<div class="page-wrap">
  <section class="card-grid">
    <article class="glass-panel editor-card">
      <p class="eyebrow">Campaign Builder</p>
      <h2 class="section-title">Create a bulk message campaign from approved templates</h2>

      <div [formGroup]="form">
        <ion-item>
          <ion-label position="stacked">Campaign name</ion-label>
          <ion-input formControlName="name"></ion-input>
        </ion-item>

        <div class="form-grid">
          <ion-item>
            <ion-label position="stacked">Template</ion-label>
            <ion-select formControlName="template_id">
              <ion-select-option *ngFor="let template of templates" [value]="template.id">
                {{ template.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Schedule</ion-label>
            <ion-datetime presentation="date-time" formControlName="scheduled_at"></ion-datetime>
          </ion-item>
        </div>

        <ion-item>
          <ion-label position="stacked">Contacts</ion-label>
          <ion-select [multiple]="true" formControlName="contact_ids">
            <ion-select-option *ngFor="let contact of contacts" [value]="contact.id">
              {{ contact.name }}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Default variables</ion-label>
          <ion-input formControlName="variable_defaults"></ion-input>
        </ion-item>

        <ion-button expand="block" (click)="create()">Create campaign</ion-button>
      </div>
    </article>

    <article class="glass-panel list-card">
      <p class="eyebrow">Campaign Queue</p>
      <ion-list lines="full">
        <ion-item *ngFor="let campaign of campaigns">
          <ion-label>
            <h3>{{ campaign.name }}</h3>
            <p>
              Template #{{ campaign.template_id }} · {{ campaign.contact_ids.length }} contacts ·
              {{ campaign.status || 'draft' }}
            </p>
          </ion-label>
          <ion-button fill="outline" size="small" (click)="dispatch(campaign)">Send</ion-button>
        </ion-item>
      </ion-list>
    </article>
  </section>
</div>
